export default "__VITE_ASSET__Ds1JGIpx__"